export default "__VITE_ASSET__CZclULWp__"